import React from "react"

export default function Loader({loaded}){
    return(
        <svg
            id="canvas"
            viewBox="0 200 800 400"
            xmlns="http://www.w3.org/2000/svg"
            className="m-auto md:w-7/12 sm:w-full"
        >
            <g
            id="redCapsule"
            className={loaded?"loaded":"loading"}
            transform="rotate(55 0 0) translate(-75.17 52.63)"
            >
            <g id="redCircle" className={loaded?"loaded":"loading"}>
                <circle
                id="redCircleTop"
                className={loaded?"loaded":"loading"}
                cx="320"
                cy="320"
                r="40"
                fill="#DB4437"
                />
                <circle
                id="redCircleBottom"
                className={loaded?"loaded":"loading"}
                cx="320"
                cy="480"
                r="40"
                fill="#DB4437"
                />
            </g>
            <rect
                id="redRect"
                className={loaded?"loaded":"loading"}
                x="280"
                y="320"
                width="80"
                height="160"
                fill="#DB4437"
            />
            </g>
            <g
            id="blueCapsule"
            className={loaded?"loaded":"loading"}
            transform="rotate(-55 0 0) translate(-7 95)"
            >
            <g id="blueCircle" className={loaded?"loaded":"loading"}>
                <circle
                id="blueCircleTop"
                className={loaded?"loaded":"loading"}
                cx="160"
                cy="320"
                r="40"
                fill="#4285F4"
                />
                <circle
                id="blueCircleBottom"
                className={loaded?"loaded":"loading"}
                cx="160"
                cy="480"
                r="40"
                fill="#4285F4"
                />
            </g>
            <rect
                id="blueRect"
                className={loaded?"loaded":"loading"}
                x="120"
                y="320"
                width="80"
                height="160"
                fill="#4285F4"
            />
            </g>
            <g
            id="yellowCapsule"
            className={loaded?"loaded":"loading"}
            transform="rotate(55 0 0) translate(75.17 0)"
            >
            <g id="yellowCircle" className={loaded?"loaded":"loading"}>
                <circle
                id="yellowCircleTop"
                className={loaded?"loaded":"loading"}
                cx="480"
                cy="320"
                r="40"
                fill="#F4B400"
                />
                <circle
                id="yellowCircleBottom"
                className={loaded?"loaded":"loading"}
                cx="480"
                cy="480"
                r="40"
                fill="#F4B400"
                />
            </g>
            <rect
                id="yellowRect"
                className={loaded?"loaded":"loading"}
                x="440"
                y="320"
                width="80"
                height="160"
                fill="#F4B400"
            />
            </g>
            <g
            id="greenCapsule"
            className={loaded?"loaded":"loading"}
            transform="rotate(-55 0 0) translate(-42 -113)"
            >
            <g id="greenCircle" className={loaded?"loaded":"loading"}>
                <circle
                id="greenCircleTop"
                className={loaded?"loaded":"loading"}
                cx="640"
                cy="320"
                r="40"
                fill="#0F9D58"
                />
                <circle
                id="greenCircleBottom"
                className={loaded?"loaded":"loading"}
                cx="640"
                cy="480"
                r="40"
                fill="#0F9D58"
                />
            </g>
            <rect
                id="greenRect"
                className={loaded?"loaded":"loading"}
                x="600"
                y="320"
                width="80"
                height="160"
                fill="#0F9D58"
            />
            </g>
        </svg>
    )
}